import React, { LabelHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { useThemeColors } from '../../providers/ThemeProvider';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  required?: boolean;
}

export function Label({ 
  children, 
  className,
  required,
  ...props 
}: LabelProps) {
  const colors = useThemeColors();
  return (
    <label
      className={cn(
        'block text-sm font-medium',
        colors.classes.textPrimary,
        'mb-1',
        className
      )}
      {...props}
    >
      {children}
      {required && (
        <span className={cn("ml-1", colors.classes.textDanger)} aria-label="required">
          *
        </span>
      )}
    </label>
  );
}